import React, { FC, memo } from "react";
import { areEqualShallow } from "Utils/areEqual";

interface Props {
  classes: any;
  icon?: any;
  title?: any;
}
const PopUpContent: FC<Props> = memo(({ classes, icon, title = "" }: Props) => {
  return (
    <div className={classes.anchor}>
      <div className={classes.bubble}>
        <span className={classes.svgIcon}>{icon && icon}</span>
        {title.length > 0 && <span>{title}</span>}
      </div>
    </div>
  );
}, areEqualShallow);
PopUpContent.defaultProps = {
  title: undefined,
  icon: undefined,
};
export default PopUpContent;
